/**
 *
 * A function to add class to social share button
 *
 *
 */
export function socialInit() {
    const shareButton = document.querySelector('.c-btn--share-icons');
    if (shareButton) {
        shareButton.addEventListener('click', openSocialButton);
    }
}

export function openSocialButton(e) {
    e.currentTarget.parentElement.classList.toggle('c-btn--open');
}